import { z } from 'zod'

export const extraServiceReservationCalendarMetaSchema = z.object({
  realPropertyArea: z.string().nullable(),
  realPropertyBuildingPart: z.string().nullable(),
  realPropertyBuilding: z.string().nullable(),
  equipment: z.string().nullable(),
  equipmentCategory: z.string().nullable(),
  city: z.string(),
  streetName: z.string(),
  streetNumber: z.string(),
  additionalDetails: z.string().nullable(),
})

export const extraServiceReservationSchema = z.object({
  id: z.number(),
  type: z.enum(['storage', 'right_of_access']),
  startDate: z.string(),
  endDate: z.string().nullable(),
  rentableHierarchyId: z.number().nullable(),
  accessPolicyId: z.number().nullable(),
  hasLockAccess: z.boolean(),
  calendarMeta: extraServiceReservationCalendarMetaSchema,
})

export const extraServiceReservationsResponseSchema = z.object({
  extraServiceReservations: z.array(extraServiceReservationSchema),
})

export type ExtraServiceReservation = z.infer<
  typeof extraServiceReservationSchema
>
export type ExtraServiceReservationsResponse = z.infer<
  typeof extraServiceReservationsResponseSchema
>
export type ExtraServiceReservationCalendarMeta = z.infer<
  typeof extraServiceReservationCalendarMetaSchema
>
